import {Exclude, Expose, instanceToPlain, plainToInstance} from "class-transformer";
import * as t from "io-ts";
import {validateJSON, validateJSONNow} from "../web/validation";
import {Entity} from "./entity";

export const ABACPolicyValidator = t.intersection([
  t.type({
    id: t.string,
    name: t.string,
    expression: t.string,
    createDttm: t.number,
    lastModifiedDttm: t.number,
  }),
  t.partial({
    description: t.string,
    createdById: t.string,
    lastModifiedById: t.string,
  }),
]);

export const ABACPolicyArrayValidator = t.array(
  ABACPolicyValidator
);

export type ABACPolicy = t.TypeOf<typeof ABACPolicyValidator>;
export type ABACPolicyArray = t.TypeOf<typeof ABACPolicyArrayValidator>;

@Exclude()
export class ABACPolicyEntity implements Entity {
  @Expose()
  id!: string;

  @Expose()
  name!: string;

  @Expose()
  description?: string;

  @Expose()
  expression!: string;

  @Expose()
  createDttm!: number;

  @Expose()
  lastModifiedDttm!: number;

  @Expose()
  createdById?: string;

  @Expose()
  lastModifiedById?: string;

  readonly entityType = 'ABAC_POLICY';

  get displayName(): Readonly<string> {
    return this.name;
  }

  /**
   * Constructor for ABACPolicyEntity. Recommend using the {@link create} method instead.
   * @hideconstructor
   */
  constructor() {
    // Empty constructor for 'class-transformer'
  }

  static from(value: ABACPolicy): ABACPolicyEntity {
    return plainToInstance(ABACPolicyEntity, value, {
      excludeExtraneousValues: true,
    });
  }

  loadTypeValue(): Promise<ABACPolicy> {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSON(ABACPolicyValidator, object);
  }

  asTypeValue(): ABACPolicy {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSONNow(ABACPolicyValidator, object);
  }
}
